/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {Pipe, PipeTransform} from '@angular/core';

import {Pay} from '../../+payrolls/ongoing/ongoing-payrolls.interfaces';
import {isBlank, isPresent} from '../utils/lang';

@Pipe({name: 'gpPayId'})
export class PayIdPipe implements PipeTransform {
  public transform(data: Pay): any {
    if (!isPresent(data)) {
      return;
    }
    if (!isBlank(data.externalNumber)) {
      return `${data.externalNumber}`;
    }
    if (!isBlank(data.externalID)) {
      return `${data.externalID}`;
    }
    return `${data.id}`;
  }
}
